import Vue from 'vue'
import OfferForm from './components/offer-form-root'
import 'url-search-params-polyfill';

let app = new Vue({
    'el': '#offer-form',
    'components': {
        'ccd-offer-form': OfferForm
    }
});


// WEBPACK FOOTER //
// ./resources/js/offer-form.js